import { Box, BoxProps } from "@chakra-ui/react";
import React from "react";

function DownArrow({ ...props }: BoxProps) {
	return (
		<Box cursor={'pointer'} {...props}>
			<svg
				width="17"
				height="16"
				viewBox="0 0 17 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.5 9.53826L3.47452 4.51278L2.5 5.4873L8.5 11.4873L14.5 5.4873L13.5255 4.51278L8.5 9.53826Z"
					fill="#798692"
				/>
			</svg>
		</Box>
	);
}

export { DownArrow };
